import React from 'react'
import {
  AccordionSummary,
  Typography,
  AccordionDetails,
  Accordion
} from '@material-ui/core'
import { useStyles } from '../Styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import FormTextField from '../../../../FormFields/FormTextField'

const Order = ({ formClasses, data, formActions }) => {
  const classes = useStyles()
  return (
    <div className={classes.IssuerReceiverWrapper + ' row'}>
      <Accordion defaultExpanded={true} elevation={0}>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon/>}
          className={classes.IssuerReceiverHeaderWrapper}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={classes.IssuerReceiverHeader}>
            <Typography className={classes.ItemHeading}>{data?.icon}{data?.title}</Typography>
          </div>
        </AccordionSummary>
        <AccordionDetails className={classes.IssuerReceiverDetailsWrapper}>

          <FormTextField name={'purchaseOrderReference'}
                         labelKey={'Fields.label.purchaseOrderReference'} classes={formClasses}
                         formActions={formActions}/>

          <FormTextField name={'purchaseOrderDescription'}
                         labelKey={'Fields.label.purchaseOrderDescription'} classes={formClasses}
                         formActions={formActions}/>

          <FormTextField name={'salesOrderReference'}
                         labelKey={'Fields.label.salesOrderReference'} classes={formClasses}
                         formActions={formActions}/>

          <FormTextField name={'salesOrderDescription'}
                         labelKey={'Fields.label.salesOrderDescription'} classes={formClasses}
                         formActions={formActions}/>

          <FormTextField name={'proformaInvoiceNumber'}
                         labelKey={'Fields.label.proformaInvoiceNumber'} classes={formClasses}
                         formActions={formActions}/>
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default Order
